import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { entityContentRouteRef, packageDependenciesRouteRef } from './routes';

export const packagesPlugin = createPlugin({
  id: 'packages',
  routes: {
    entityContent: entityContentRouteRef,
  },
});

export const EntityPackagesContent = packagesPlugin.provide(
  createRoutableExtension({
    name: 'EntityPackagesContent',
    component: () => import('./Router').then(m => m.Router),
    mountPoint: entityContentRouteRef,
  }),
);

export const packageDependenciesPlugin = createPlugin({
  id: 'packagedependencies',
  routes: {
    packageDependencies: packageDependenciesRouteRef,
  },
});

export const PackageDependenciesPage = packageDependenciesPlugin.provide(
  createRoutableExtension({
    name: 'PackageDependenciesPage',
    component: () =>
      import('./components/PackageDependenciesPage').then(
        m => m.PackageDependenciesPage,
      ),
    mountPoint: packageDependenciesRouteRef,
  }),
);
